import { Href } from "../../../../../Constants/Constants";
import SvgIcon from "../../../../CommonComponents/SvgIcon";

const DocumentChat = () => {
  return (
    <div className="document">
      <div className="document-icon">
        <SvgIcon iconId="pdf-file" />
      </div>
      <div className="details">
        <h4 className="p-0 font-light">Smitten Shah 01.pdf</h4>
        <h6>1 Page | 250 kb</h6>
      </div>
      <div className="icon-btns">
        <a href={Href}><SvgIcon iconId="document-download" /></a>
      </div>
    </div>
  );
};

export default DocumentChat;
